module.exports = __webpack_public_path__ + "img/action7.6a5da1fd.jpg";